/**
 * Created by vladislav on 4/2/2024
 */

const PaymentsDetector = function () {
    if (connector.config.paymentsDisabled) {
        return NoPayments;
    }

    let PluginClass;

    const types = [
        typeof DiscordPayments !== "undefined" && DiscordPayments,
        typeof RuStorePayments !== "undefined" && RuStorePayments,
        typeof RoboKassaPayments !== "undefined" && RoboKassaPayments,
        typeof YooKassaPayments !== "undefined" && YooKassaPayments,
        typeof WebViewPayments !== "undefined" && WebViewPayments,
        typeof OneStorePayments !== "undefined" && OneStorePayments,
        typeof MSStartPayments !== "undefined" && MSStartPayments,
        typeof CrazyXsollaPayments !== "undefined" && CrazyXsollaPayments,
        typeof XsollaPayments !== "undefined" && XsollaPayments,
        typeof TestRestPayments !== "undefined" && TestRestPayments,
        typeof TestPayments !== "undefined" && TestPayments,
        typeof InstantPayments !== "undefined" && InstantPayments,
        typeof SPMobagePayments !== "undefined" && SPMobagePayments,
        typeof OKPayments !== "undefined" && OKPayments,
        typeof MobileMyMailRuPayments !== "undefined" && MobileMyMailRuPayments,
        typeof SamsungPayments !== "undefined" && SamsungPayments,
        typeof MyMailRuPayments !== "undefined" && MyMailRuPayments,
        typeof OKBridgePayments !== "undefined" && OKBridgePayments,
        typeof VKPayments !== "undefined" && VKPayments,
        typeof MobagePayments !== "undefined" && MobagePayments,
        typeof FotoStranaPayments !== "undefined" && FotoStranaPayments,
        typeof DraugiemPayments !== "undefined" && DraugiemPayments,
        typeof YandexPayments !== "undefined" && YandexPayments,
        typeof MicrosoftPayments !== "undefined" && MicrosoftPayments,
        typeof PlingaPayments !== "undefined" && PlingaPayments,
        typeof KongregatePayments !== "undefined" && KongregatePayments,
        typeof TelegramPayments !== "undefined" && TelegramPayments,
        typeof MSPwaPayments !== "undefined" && MSPwaPayments,
        typeof MygamesPayments !== "undefined" && MygamesPayments,
        typeof WechatPayments !== "undefined" && WechatPayments,
        typeof GDComPayments !== "undefined" && GDComPayments,
        typeof TikTokPayments !== "undefined" && TikTokPayments,
        typeof RedditPayments !== "undefined" && RedditPayments,
        typeof EpicGamesPayments !== "undefined" && EpicGamesPayments,
        typeof ArkadiumPayments !== "undefined" && ArkadiumPayments
    ];

    for (let i = 0; i < types.length; i++) {
        if (types[i] && types[i].isAppropriate()) {
            PluginClass = types[i];
            break;
        }
    }

    return PluginClass || NoPayments;
};